import React from 'react';
import clsx from 'clsx';

import styles from './Card.module.scss';

type CardProps = {
  children: React.ReactNode;
  wide?: boolean;
};

export const Card = ({ children, wide = false }: CardProps) => {
  return <div className={clsx(styles.card, wide && styles.wide)}>{children}</div>;
};
